import PropTypes from "prop-types";
import StatusTags, { STATUS } from '@/componentsDS/Tags/StatusTags';
import Tags from '@/componentsDS/Tags/Tags';
import { ReactComponent as CheckHistory } from "@/assets/svgs/DesignSystem/check-history.svg";

const SharedDataStatus = ({ status, isReceivedData = false }) => {
	status = status?.toUpperCase();
	return (
		<>
			{status === "PENDING_APPROVAL" && <StatusTags status={STATUS.PENDING_APPROVAL} />}
			{status === "APPROVED" && <StatusTags status={STATUS.APPROVED} />}
			{status === "REJECTED" && <StatusTags status={STATUS.REJECTED} />}
			{status === "PENDING" && !isReceivedData && <StatusTags status={STATUS.SENDING} /> }
			{status === "PENDING" && isReceivedData && (
				<Tags
					label='Receiving'
					prefixIcon={<CheckHistory />}
					tagClassName="DS__tag--system"
				/>
			)}
			{status === "SUCCESS" && isReceivedData && <StatusTags status={STATUS.RECEIVED} />}
			{status === "SUCCESS" && !isReceivedData && <StatusTags status={STATUS.SENT} />}
			{status === "FAIL" && <StatusTags status={STATUS.FAILED} />}
			{status === "EXPIRED" && <StatusTags status={STATUS.EXPIRED} />}
			{status === "COPY_SUCCESS" && <StatusTags status={STATUS.COPY_SUCCESS} />}
			{status === "COPY_FAILED" && <StatusTags status={STATUS.COPY_FAILED} />}
		</>
	)
};

SharedDataStatus.propTypes = {
	status: PropTypes.string.isRequired,
	isReceivedData: PropTypes.bool,
}

export default SharedDataStatus;
